import React from 'react';
import PropTypes from 'prop-types';

import './form-page.scss';

const InputWrapper = ({ children, label, name, required, width }) => (
  <div className="input-wrapper">
    {label && (
      <label htmlFor={name}>
        {label}
        {required && '*'}
      </label>
    )}
    <div className="inputs" style={{ width: `${width}%` }}>
      {children}
    </div>
  </div>
);

InputWrapper.propTypes = {
  width: PropTypes.number,
};

InputWrapper.defaultProps = {
  width: 100,
};

export default InputWrapper;
